/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../public/upgrade/feature/booking/email-tooltip.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '../../../../../public/upgrade/root/ga/ga.service';
import * as import7 from '../../../../../public/upgrade/core/mobile.service';
import * as import8 from '../../../../../public/upgrade/feature/booking/booking.service';
import * as import9 from '@angular/core/src/linker/view_type';
import * as import10 from '@angular/core/src/change_detection/constants';
import * as import11 from '@angular/core/src/linker/component_factory';
import * as import12 from '@angular/http/src/http';
import * as import13 from '../../../../../public/upgrade/root/toast/notification.service';
import * as import14 from '../../../../../public/upgrade/core/session.service';
import * as import15 from '@ngx-translate/core/src/translate.pipe';
import * as import16 from '@ngx-translate/core/src/translate.service';
export class Wrapper_EmailTooltipComponent {
  /*private*/ _eventHandler:Function;
  context:import0.EmailTooltipComponent;
  /*private*/ _changed:boolean;
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  /*private*/ _expr_2:any;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any) {
    this._changed = false;
    this.context = new import0.EmailTooltipComponent(p0,p1,p2,p3,p4);
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
    this._expr_2 = import1.UNINITIALIZED;
  }
  ngOnDetach(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  check_bookingOid(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this._changed = true;
      this.context.bookingOid = currValue;
      this._expr_0 = currValue;
    }
  }
  check_companyOid(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this._changed = true;
      this.context.companyOid = currValue;
      this._expr_1 = currValue;
    }
  }
  check_gaValue(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_2,currValue))) {
      this._changed = true;
      this.context.gaValue = currValue;
      this._expr_2 = currValue;
    }
  }
  ngDoCheck(view:import2.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  checkHost(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import2.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_EmailTooltipComponent_Host:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,([] as any[]),{});
class View_EmailTooltipComponent_Host0 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import0.EmailTooltipComponent>;
  _GAService_0_3:import6.GAService;
  _MobileService_0_4:import7.MobileService;
  _BookingService_0_5:import8.BookingService;
  _EmailTooltipComponent_0_6:Wrapper_EmailTooltipComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_EmailTooltipComponent_Host0,renderType_EmailTooltipComponent_Host,import9.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import11.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'email-tooltip',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_EmailTooltipComponent0(this.viewUtils,this,0,this._el_0);
    this._GAService_0_3 = new import6.GAService();
    this._MobileService_0_4 = new import7.MobileService();
    this._BookingService_0_5 = new import8.BookingService(this.injectorGet(import12.Http,this.parentIndex));
    this._EmailTooltipComponent_0_6 = new Wrapper_EmailTooltipComponent(this._GAService_0_3,this._MobileService_0_4,this._BookingService_0_5,this.injectorGet(import13.NotificationService,this.parentIndex),this.injectorGet(import14.SessionService,this.parentIndex));
    this.compView_0.create(this._EmailTooltipComponent_0_6.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import11.ComponentRef_<any>(0,this,this._el_0,this._EmailTooltipComponent_0_6.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import6.GAService) && (0 === requestNodeIndex))) { return this._GAService_0_3; }
    if (((token === import7.MobileService) && (0 === requestNodeIndex))) { return this._MobileService_0_4; }
    if (((token === import8.BookingService) && (0 === requestNodeIndex))) { return this._BookingService_0_5; }
    if (((token === import0.EmailTooltipComponent) && (0 === requestNodeIndex))) { return this._EmailTooltipComponent_0_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._EmailTooltipComponent_0_6.ngDoCheck(this,this._el_0,throwOnChange);
    if (!throwOnChange) { this._EmailTooltipComponent_0_6.context.ngAfterContentChecked(); }
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const EmailTooltipComponentNgFactory:import11.ComponentFactory<import0.EmailTooltipComponent> = new import11.ComponentFactory<import0.EmailTooltipComponent>('email-tooltip',View_EmailTooltipComponent_Host0,import0.EmailTooltipComponent);
const styles_EmailTooltipComponent:any[] = ([] as any[]);
var renderType_EmailTooltipComponent:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,styles_EmailTooltipComponent,{});
export class View_EmailTooltipComponent0 extends import2.AppView<import0.EmailTooltipComponent> {
  _text_0:any;
  _el_1:any;
  _text_2:any;
  _el_3:any;
  _text_4:any;
  _el_5:any;
  _text_6:any;
  _el_7:any;
  _text_8:any;
  _el_9:any;
  _text_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _text_14:any;
  _text_15:any;
  _text_16:any;
  _el_17:any;
  _text_18:any;
  _el_19:any;
  _text_20:any;
  _el_21:any;
  _text_22:any;
  _el_23:any;
  _text_24:any;
  _el_25:any;
  _text_26:any;
  _text_27:any;
  _el_28:any;
  _text_29:any;
  _el_30:any;
  _text_31:any;
  _el_32:any;
  _text_33:any;
  _el_34:any;
  _text_35:any;
  _el_36:any;
  _text_37:any;
  _text_38:any;
  _text_39:any;
  _text_40:any;
  _el_41:any;
  _text_42:any;
  _el_43:any;
  _text_44:any;
  _text_45:any;
  _el_46:any;
  _text_47:any;
  _text_48:any;
  _text_49:any;
  _text_50:any;
  _text_51:any;
  /*private*/ _expr_52:any;
  /*private*/ _expr_53:any;
  /*private*/ _expr_54:any;
  /*private*/ _expr_55:any;
  _pipe_translate_0:import15.TranslatePipe;
  /*private*/ _expr_57:any;
  _pipe_translate_1:import15.TranslatePipe;
  /*private*/ _expr_59:any;
  /*private*/ _expr_60:any;
  _pipe_translate_2:import15.TranslatePipe;
  /*private*/ _expr_62:any;
  /*private*/ _expr_63:any;
  /*private*/ _expr_64:any;
  /*private*/ _expr_65:any;
  _pipe_translate_3:import15.TranslatePipe;
  /*private*/ _expr_67:any;
  /*private*/ _expr_68:any;
  _pipe_translate_4:import15.TranslatePipe;
  /*private*/ _expr_70:any;
  /*private*/ _expr_71:any;
  _pipe_translate_5:import15.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_EmailTooltipComponent0,renderType_EmailTooltipComponent,import9.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways);
    this._expr_52 = import1.UNINITIALIZED;
    this._expr_53 = import1.UNINITIALIZED;
    this._expr_54 = import1.UNINITIALIZED;
    this._expr_55 = import1.UNINITIALIZED;
    this._expr_57 = import1.UNINITIALIZED;
    this._expr_59 = import1.UNINITIALIZED;
    this._expr_60 = import1.UNINITIALIZED;
    this._expr_62 = import1.UNINITIALIZED;
    this._expr_63 = import1.UNINITIALIZED;
    this._expr_64 = import1.UNINITIALIZED;
    this._expr_65 = import1.UNINITIALIZED;
    this._expr_67 = import1.UNINITIALIZED;
    this._expr_68 = import1.UNINITIALIZED;
    this._expr_70 = import1.UNINITIALIZED;
    this._expr_71 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import11.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._text_0 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._el_1 = import3.createRenderElement(this.renderer,parentRenderNode,'section',new import3.InlineArray4(4,'class','eva-3-tooltip -center -white -close -not-hover','name','tooltip-position'),(null as any));
    this._text_2 = this.renderer.createText(this._el_1,'\n    ',(null as any));
    this._el_3 = import3.createRenderElement(this.renderer,this._el_1,'div',new import3.InlineArray2(2,'class','tooltip-row custom-position'),(null as any));
    this._text_4 = this.renderer.createText(this._el_3,'\n        ',(null as any));
    this._el_5 = import3.createRenderElement(this.renderer,this._el_3,'button',new import3.InlineArray4(4,'class','eva-3-btn-ghost -icon -blue','name','contact-button'),(null as any));
    this._text_6 = this.renderer.createText(this._el_5,'\n            ',(null as any));
    this._el_7 = import3.createRenderElement(this.renderer,this._el_5,'i',new import3.InlineArray2(2,'class','btn-icon eva-3-icon-mail'),(null as any));
    this._text_8 = this.renderer.createText(this._el_5,'\n            ',(null as any));
    this._el_9 = import3.createRenderElement(this.renderer,this._el_5,'em',new import3.InlineArray2(2,'class','btn-text'),(null as any));
    this._text_10 = this.renderer.createText(this._el_9,'',(null as any));
    this._text_11 = this.renderer.createText(this._el_5,'\n            ',(null as any));
    this._el_12 = import3.createRenderElement(this.renderer,this._el_5,'span',new import3.InlineArray2(2,'class','btn-status'),(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'',(null as any));
    this._text_14 = this.renderer.createText(this._el_5,'\n        ',(null as any));
    this._text_15 = this.renderer.createText(this._el_3,'\n    ',(null as any));
    this._text_16 = this.renderer.createText(this._el_1,'\n    ',(null as any));
    this._el_17 = import3.createRenderElement(this.renderer,this._el_1,'section',new import3.InlineArray2(2,'class','tooltip-container tooltip-custom'),(null as any));
    this._text_18 = this.renderer.createText(this._el_17,'\n        ',(null as any));
    this._el_19 = import3.createRenderElement(this.renderer,this._el_17,'i',new import3.InlineArray2(2,'class','tooltip-marker'),(null as any));
    this._text_20 = this.renderer.createText(this._el_17,'\n        ',(null as any));
    this._el_21 = import3.createRenderElement(this.renderer,this._el_17,'i',new import3.InlineArray2(2,'class','tooltip-close eva-3-icon-close'),(null as any));
    this._text_22 = this.renderer.createText(this._el_17,'\n        ',(null as any));
    this._el_23 = import3.createRenderElement(this.renderer,this._el_17,'div',new import3.InlineArray2(2,'class','tooltip-content'),(null as any));
    this._text_24 = this.renderer.createText(this._el_23,'\n            ',(null as any));
    this._el_25 = import3.createRenderElement(this.renderer,this._el_23,'h6',new import3.InlineArray2(2,'class','eva-3-h6'),(null as any));
    this._text_26 = this.renderer.createText(this._el_25,'',(null as any));
    this._text_27 = this.renderer.createText(this._el_23,'\n            ',(null as any));
    this._el_28 = import3.createRenderElement(this.renderer,this._el_23,'input',new import3.InlineArray8(6,'class','input-tooltip input-gradient','readonly','','type','text'),(null as any));
    this._text_29 = this.renderer.createText(this._el_23,'\n            ',(null as any));
    this._el_30 = import3.createRenderElement(this.renderer,this._el_23,'div',new import3.InlineArray4(4,'class','eva-3-btn-ghost -blue','name','copy-button'),(null as any));
    this._text_31 = this.renderer.createText(this._el_30,'\n                                            ',(null as any));
    this._el_32 = import3.createRenderElement(this.renderer,this._el_30,'span',new import3.InlineArray2(2,'class','btn-text'),(null as any));
    this._text_33 = this.renderer.createText(this._el_32,'\n                                               ',(null as any));
    this._el_34 = import3.createRenderElement(this.renderer,this._el_32,'i',new import3.InlineArray2(2,'class','-eva-3-icon-xsm eva-3-icon-copy'),(null as any));
    this._text_35 = this.renderer.createText(this._el_32,'\n                                                ',(null as any));
    this._el_36 = import3.createRenderElement(this.renderer,this._el_32,'em',new import3.InlineArray2(2,'class','icon-text'),(null as any));
    this._text_37 = this.renderer.createText(this._el_36,'',(null as any));
    this._text_38 = this.renderer.createText(this._el_32,'\n                                            ',(null as any));
    this._text_39 = this.renderer.createText(this._el_30,'\n            ',(null as any));
    this._text_40 = this.renderer.createText(this._el_23,'\n            ',(null as any));
    this._el_41 = import3.createRenderElement(this.renderer,this._el_23,'div',new import3.InlineArray2(2,'class','-eva-3-tc-green-2 -eva-3-hide'),(null as any));
    this._text_42 = this.renderer.createText(this._el_41,'\n                ',(null as any));
    this._el_43 = import3.createRenderElement(this.renderer,this._el_41,'i',new import3.InlineArray2(2,'class','-eva-3-icon-xxsm eva-3-icon-checkmark-circle -eva-3-mr-xsm'),(null as any));
    this._text_44 = this.renderer.createText(this._el_41,'',(null as any));
    this._text_45 = this.renderer.createText(this._el_23,'\n            ',(null as any));
    this._el_46 = import3.createRenderElement(this.renderer,this._el_23,'p',new import3.InlineArray2(2,'class','tooltip-text'),(null as any));
    this._text_47 = this.renderer.createText(this._el_46,'',(null as any));
    this._text_48 = this.renderer.createText(this._el_23,'\n        ',(null as any));
    this._text_49 = this.renderer.createText(this._el_17,'\n    ',(null as any));
    this._text_50 = this.renderer.createText(this._el_1,'\n',(null as any));
    this._text_51 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_5,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_5));
    this._pipe_translate_0 = new import15.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_1 = new import15.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.ref);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_17,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_17));
    var disposable_2:Function = import3.subscribeToRenderElement(this,this._el_21,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_21));
    this._pipe_translate_2 = new import15.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.ref);
    var disposable_3:Function = import3.subscribeToRenderElement(this,this._el_30,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_30));
    this._pipe_translate_3 = new import15.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_4 = new import15.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_5 = new import15.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.ref);
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._text_0,
      this._el_1,
      this._text_2,
      this._el_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._el_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._text_14,
      this._text_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._el_19,
      this._text_20,
      this._el_21,
      this._text_22,
      this._el_23,
      this._text_24,
      this._el_25,
      this._text_26,
      this._text_27,
      this._el_28,
      this._text_29,
      this._el_30,
      this._text_31,
      this._el_32,
      this._text_33,
      this._el_34,
      this._text_35,
      this._el_36,
      this._text_37,
      this._text_38,
      this._text_39,
      this._text_40,
      this._el_41,
      this._text_42,
      this._el_43,
      this._text_44,
      this._text_45,
      this._el_46,
      this._text_47,
      this._text_48,
      this._text_49,
      this._text_50,
      this._text_51
    ]
    ),[
      disposable_0,
      disposable_1,
      disposable_2,
      disposable_3
    ]
    );
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_52:any = import3.inlineInterpolate(1,'tooltipMail-',this.context.bookingOid,'');
    if (import3.checkBinding(throwOnChange,this._expr_52,currVal_52)) {
      this.renderer.setElementProperty(this._el_1,'id',currVal_52);
      this._expr_52 = currVal_52;
    }
    const currVal_53:any = this.context.isDisable;
    if (import3.checkBinding(throwOnChange,this._expr_53,currVal_53)) {
      this.renderer.setElementProperty(this._el_5,'disabled',currVal_53);
      this._expr_53 = currVal_53;
    }
    const currVal_54:any = import3.inlineInterpolate(1,'buttonLoader-',this.context.bookingOid,'');
    if (import3.checkBinding(throwOnChange,this._expr_54,currVal_54)) {
      this.renderer.setElementProperty(this._el_5,'id',currVal_54);
      this._expr_54 = currVal_54;
    }
    valUnwrapper.reset();
    const currVal_55:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('emailTooltip.email.button')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_55,currVal_55))) {
      this.renderer.setText(this._text_10,currVal_55);
      this._expr_55 = currVal_55;
    }
    valUnwrapper.reset();
    const currVal_57:any = import3.inlineInterpolate(1,' ',valUnwrapper.unwrap(this._pipe_translate_1.transform('emailTooltip.email.loading')),' ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_57,currVal_57))) {
      this.renderer.setText(this._text_13,currVal_57);
      this._expr_57 = currVal_57;
    }
    const currVal_59:any = import3.inlineInterpolate(1,'',this.context.bookingOid,'');
    if (import3.checkBinding(throwOnChange,this._expr_59,currVal_59)) {
      this.renderer.setElementProperty(this._el_17,'id',currVal_59);
      this._expr_59 = currVal_59;
    }
    valUnwrapper.reset();
    const currVal_60:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_2.transform('emailTooltip.email.tooltipTitle')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_60,currVal_60))) {
      this.renderer.setText(this._text_26,currVal_60);
      this._expr_60 = currVal_60;
    }
    const currVal_62:any = import3.inlineInterpolate(1,'eva-input-mail-',this.context.bookingOid,'');
    if (import3.checkBinding(throwOnChange,this._expr_62,currVal_62)) {
      this.renderer.setElementProperty(this._el_28,'id',currVal_62);
      this._expr_62 = currVal_62;
    }
    const currVal_63:any = import3.inlineInterpolate(1,'',this.context.clientMail,'');
    if (import3.checkBinding(throwOnChange,this._expr_63,currVal_63)) {
      this.renderer.setElementProperty(this._el_28,'value',currVal_63);
      this._expr_63 = currVal_63;
    }
    const currVal_64:any = import3.inlineInterpolate(1,'copiedMail-',this.context.bookingOid,'');
    if (import3.checkBinding(throwOnChange,this._expr_64,currVal_64)) {
      this.renderer.setElementProperty(this._el_30,'id',currVal_64);
      this._expr_64 = currVal_64;
    }
    valUnwrapper.reset();
    const currVal_65:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_3.transform('emailTooltip.email.copyButton')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_65,currVal_65))) {
      this.renderer.setText(this._text_37,currVal_65);
      this._expr_65 = currVal_65;
    }
    const currVal_67:any = import3.inlineInterpolate(1,'greenElement-',this.context.bookingOid,'');
    if (import3.checkBinding(throwOnChange,this._expr_67,currVal_67)) {
      this.renderer.setElementProperty(this._el_41,'id',currVal_67);
      this._expr_67 = currVal_67;
    }
    valUnwrapper.reset();
    const currVal_68:any = import3.inlineInterpolate(1,'\n                ',valUnwrapper.unwrap(this._pipe_translate_4.transform('emailTooltip.email.successCopy')),'\n            ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_68,currVal_68))) {
      this.renderer.setText(this._text_44,currVal_68);
      this._expr_68 = currVal_68;
    }
    const currVal_70:any = import3.inlineInterpolate(1,'footer-',this.context.bookingOid,'');
    if (import3.checkBinding(throwOnChange,this._expr_70,currVal_70)) {
      this.renderer.setElementProperty(this._el_46,'id',currVal_70);
      this._expr_70 = currVal_70;
    }
    valUnwrapper.reset();
    const currVal_71:any = import3.inlineInterpolate(2,'',valUnwrapper.unwrap(this._pipe_translate_5.transform('emailTooltip.email.tooltipFooter')),' ',this.context.companyMail,'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_71,currVal_71))) {
      this.renderer.setText(this._text_47,currVal_71);
      this._expr_71 = currVal_71;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
    this._pipe_translate_3.ngOnDestroy();
    this._pipe_translate_4.ngOnDestroy();
    this._pipe_translate_5.ngOnDestroy();
  }
  handleEvent_5(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.toggleTooltip($event,this.context.bookingOid,true)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_17(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>$event.stopPropagation()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_21(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.toggleTooltip($event,this.context.bookingOid)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_30(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.copyMail(this.context.bookingOid)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/feature/booking/email-tooltip.component.ngfactory.ts